import { FormControl } from '@material-ui/core';
import { validateEmail } from 'features/login/validation-constants';
import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { UserPasswordResetRequest } from 'model/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { forgotPasswordRequest, forgotPasswordResetState } from 'reducer/account/forgot-password/actions';
import { useForgotPasswordState, useRootDispatch } from 'reducer/hooks';
import FieldBasic from '../../components/field-basic/field-basic';
import ModalForgotPassword from './components/modal-forgot-password';
import './forgot-password.scss';

const useForgotPasswordAwareness = () => {
    const state = useForgotPasswordState();

    const isLoading = state.status === HttpRequestStatus.ONGOING;

    return { isLoading };
};

const useShowSuccess = () => {
    const state = useForgotPasswordState();
    const [showModal, setShowModal] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (state.status === HttpRequestStatus.SUCCESS) {
            setShowModal(ps => true);
        } else {
            setShowModal(ps => false);
        }
    }, [state.status, setShowModal]);

    return { showModal };
};

const useCleanState = () => {
    const dispatch = useRootDispatch();

    React.useEffect(() => {
        return () => {
            dispatch(forgotPasswordResetState());
        };
    }, [dispatch]);
};

export const ForgotPassword = () => {
    const { t } = useTranslation();

    const history = useHistory();
    const dispatch = useRootDispatch();

    useCleanState();

    const [email, setEmail] = React.useState<string>('');
    const [showValidation, setValidation] = React.useState<boolean>(false);

    const { isLoading } = useForgotPasswordAwareness();
    const { showModal } = useShowSuccess();

    const haltProgression = !validateEmail(email).isValid;

    const handleClick = async () => {
        setValidation(true);
        if (haltProgression) return;

        const _email = email;
        const payload: UserPasswordResetRequest = { email: _email };
        dispatch(forgotPasswordRequest(payload));
    };

    const handleCloseModal = () => {
        history.goBack();
    };

    return (
        <div style={{ marginTop: '150px' }} className="body__forgot-password">
            <Row>
                <Col style={{ margin: 'auto' }} md={{ size: 3 }}>
                    <div className="body__forgot-password--title">{t('forgot-password.finish.title')}</div>
                    <form className="form__style">
                        <FieldBasic label={t('forgot-password.init.label')} validate={validateEmail} onChange={setEmail} autoComplete="username" showValidation={showValidation} />
                        <FormControl className="forgot-password--text" fullWidth variant="filled">
                            {t('forgot-password.init.tip')}
                        </FormControl>
                    </form>
                    <div style={{ textAlign: 'center' }}>
                        <button className="forgot-password--button" onClick={handleClick} disabled={(showValidation && haltProgression) || isLoading}>
                            {t('forgot-password.buttons.submit').toUpperCase()}
                        </button>
                    </div>
                </Col>
            </Row>
            <ModalForgotPassword title={t('forgot-password.init.success.title')} message={t('forgot-password.init.success.message')} action={t('forgot-password.init.success.action')} open={showModal} closeModal={handleCloseModal} />
        </div>
    );
};

export default ForgotPassword;
